import QueryString from 'query-string';

import Browser from '@wetransfer/concorde-browser';
import Cookie from '@wetransfer/concorde-cookie';

import Config from '@app/config';

import Visibility from '@component/wallpaper/visibility';

let transferType = 'u';
let loggedIn = false;

export default class Environment {
  static setLoggedIn(state = false) {
    loggedIn = state;
  }

  static supportsHTML() {
    // Don't support HTML on Mobile
    if (Browser.isMobile || Browser.isTablet) {
      return false;
    }

    // If we actively prevent interactive ads
    const hasStaticCookie = parseInt(Cookie.get('wt_onlystaticads'), 10) > 0;
    if (hasStaticCookie) {
      return false;
    }

    // Make sure this is a valid browser
    return !Browser.isOutdated(Config.supportedBrowsers);
  }

  static isPlusUser() {
    return loggedIn ? 'yes' : 'no';
  }

  static setTransferType(type = 'u') {
    transferType = type;
  }

  static getTransferType() {
    return transferType;
  }

  static getParams() {
    const clientParams = QueryString.parse(location.search);
    const optionalParams = {};

    // Overwrite OpenX IP
    if ('openxip' in clientParams) {
      optionalParams['ip'] = clientParams['openxip'];
    }

    let isTabVisible = false;
    Visibility.enable((visible) => {
      isTabVisible = visible;
    });

    return {
      cb: Math.floor(Math.random() * 9999999), // To prevent cache
      'c.flash': 'no', // We don't want no (#!$@?) Flash
      'c.newsite': 'yes', // To identify "new version" TODO: Remove after 100% rollout is done
      'c.html': Environment.supportsHTML() ? 'yes' : 'no',
      'c.plus': Environment.isPlusUser(),
      'c.state': Environment.getTransferType(),
      'c.tabvisible': isTabVisible ? 'yes' : 'no',
      ...optionalParams,
    };
  }
}
